import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20serene%20study%20room%20with%20soft%20natural%20window%20light%2C%20wooden%20desk%20with%20open%20notebook%20and%20fountain%20pen%2C%20worn%20leather%20books%20on%20shelves%2C%20gentle%20sunbeams%20streaming%20through%20curtains%2C%20nostalgic%20academic%20atmosphere%2C%20cream%20and%20warm%20beige%20tones%2C%20editorial%20photography%20style%20with%20soft%20focus%20background&width=1600&height=900&seq=hero-dapigu-2026&orientation=landscape"
          alt="打屁股作文写作素材平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
            打屁股作文
            <span className="block text-lg md:text-xl font-normal text-background-50/80 mt-3">
              经典惩罚场景作文素材与写作技巧
            </span>
          </h1>
          <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto mb-8 leading-relaxed">
            专注「打屁股作文」主题，提供经典校园与家庭惩罚场景的作文素材、范文赏析及写作技巧。帮助学生掌握如何在记叙文、成长类作文中生动描写受罚经历，提升情感表达与细节刻画能力。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/fanwen-shangxi"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer shadow-lg shadow-primary-500/25"
            >
              <i className="ri-article-line mr-2"></i>
              浏览精选范文
            </Link>
            <Link
              to="/category/xijie-kehua"
              className="px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm whitespace-nowrap hover:bg-background-50/25 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-book-open-line mr-2"></i>
              学习写作技巧
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}